"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const CheckRounded_1 = __importDefault(require("@mui/icons-material/CheckRounded"));
const ListSubheader_1 = __importDefault(require("@mui/material/ListSubheader"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const KeyboardArrowRightRounded_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRightRounded"));
// @ts-expect-error: component returns Element[] which is not assignable to FC return type ReactElement|null
const QMenuList = ({ selected, theme, classes, hover, keyDown, handleClick, anchorHover, onChange, subMouseEntered, name, subMenuType, item, checkIconClassName, }) => {
    const mySubMenu = (0, react_1.useRef)(null);
    const dividerStyle = (0, react_1.useCallback)((listItem) => listItem.divider ? {
        borderBottom: 'solid',
        borderBottomWidth: '1px',
        borderBottomColor: theme.palette.border.default,
        paddingBottom: theme.shape.padding[2],
        marginBottom: theme.shape.padding[2],
    } : undefined, [theme]);
    const makeCheckListItem = (0, react_1.useCallback)((checkListItem, isSelected, groupId) => {
        const id = checkListItem.value;
        return (<ListItem_1.default 
        // @ts-expect-error: button prop deprecated in MUI v5 but still functional at runtime
        button onClick={(e) => {
                e.stopPropagation();
                handleClick(id, groupId, checkListItem.noCloseOnClick);
            }} key={`qmenu_li_${checkListItem.value}_${checkListItem.label}`} id={`qmenu_id_${checkListItem.label}`} value={isSelected ? 'on' : 'off'} style={dividerStyle(checkListItem)} className={classes.standardItemHoverContainer}>
          {isSelected && (<ListItemIcon_1.default className={classes.listIcon} style={{ minWidth: 0 }}>
              <CheckRounded_1.default className={checkIconClassName}/>
            </ListItemIcon_1.default>)}
          {!isSelected && <div className={classes.iconFiller}/>}

          <Typography_1.default variant="body2">{checkListItem.label}</Typography_1.default>
        </ListItem_1.default>);
    }, [classes, handleClick, dividerStyle, checkIconClassName]);
    const data = (0, react_1.useMemo)(() => {
        var _a;
        const result = [];
        if (item.isSubheader || item.isGroupList) {
            if (item.label) {
                result.push(<ListSubheader_1.default key={`qmenu_sub_${item.label}`} className={classes.parentList} disableSticky>
            <ListItemText_1.default className={classes.menuSubHead} secondary={item.label}/>
          </ListSubheader_1.default>);
            }
            if (item.isGroupList) {
                (_a = item.groupList) === null || _a === void 0 ? void 0 : _a.forEach((x) => {
                    result.push(makeCheckListItem(x, (item.selected === x.value || x.selected), item.groupId));
                });
            }
        }
        else if (item.customRender) {
            result.push(<div key={`qmenu_custom_${item.value}`} onMouseEnter={(e) => hover(e, JSON.stringify(item.value))}>
          <MenuItem_1.default style={dividerStyle(item)} id={`qmenu_id_${item.label}`} onKeyDown={(_) => keyDown} onClick={(e) => {
                    e.stopPropagation();
                    handleClick(item.value);
                }}>
            {item.customRender}
          </MenuItem_1.default>
        </div>);
        }
        else if (selected) {
            result.push(makeCheckListItem(item, selected === item.value));
        }
        else if (item.subMenu) {
            const SubMenu = subMenuType;
            result.push(<ListItem_1.default dense button key={`qmenu_sub_${item.label}`} className={classes.standardItemHoverContainer} onMouseEnter={(e) => hover(e, JSON.stringify(item.value))} onKeyDown={(e) => {
                    if (e.key === 'ArrowRight' && mySubMenu.current) {
                        mySubMenu.current.initMenu(e);
                    }
                    return true;
                }} onClick={(e) => {
                    if (item.itemOpensMenu) {
                        if (mySubMenu.current) {
                            mySubMenu.current.initMenu(e);
                        }
                        return true;
                    }
                    return (item.value ? handleClick(item.value, null, item.noCloseOnClick) : null);
                }}>
          <ListItemText_1.default id={`qmenu_sub_${item.label}`} primary={item.label} style={dividerStyle(item)} classes={{ root: classes.listTextRoot, primary: classes.listText }}/>
          <SubMenu ref={mySubMenu} anchorEl={anchorHover} menuIcon={KeyboardArrowRightRounded_1.default} menuIconButtonSize="small-no-padding" menuStyle={{ lineHeight: '0px' }} viewBox="-3 0 27 27" onChange={onChange} options={item.subMenu} theme={theme} classes={classes} subMouseEntered={subMouseEntered} transformOrigin={{ horizontal: 'left', vertical: 'top' }} name={`${name}:sub:${item.label}`}>
          </SubMenu>
        </ListItem_1.default>);
        }
        else {
            result.push(<ListItem_1.default dense style={dividerStyle(item)} className={(0, classnames_1.default)(classes.standardItem, classes.standardItemHoverContainer)} id={`qmenu_id_${item.label}`} key={`qmenu_li_${JSON.stringify(item.value)}`} button onClick={(e) => {
                    e.stopPropagation();
                    handleClick(item.value);
                }} selected={selected === item.label}>
          <div onMouseEnter={(e) => hover(e, JSON.stringify(item.value))} className={item.subIndent ? classes.subIndent : ''}>
            <ListItemText_1.default primary={item.label} classes={{ root: classes.listTextRoot, primary: classes.listText }}/>
          </div>
        </ListItem_1.default>);
        }
        return result;
    }, [item, selected, name, subMouseEntered, classes, hover, handleClick, keyDown, anchorHover, onChange, subMenuType, theme, dividerStyle, makeCheckListItem]);
    return data;
};
exports.default = QMenuList;
